import en from './en';
import fr from './fr';
import it from './it';
import tr from './tr';
import ar from './ar';

// 👇 temporary language (later from context / state)
const currentLang = 'en';

export const contents = {
  en,
  fr,
  it,
  tr,
  ar,
};

// ✅ DEFAULT EXPORT BACK
const content = contents[currentLang];
export default content;
